import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useMutation } from '@apollo/client'
import { Close, Delete } from '@mui/icons-material'
import styles from './revokeTokenAndValidDeleteClient.module.scss'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import { REVOKE_ALL_API_CLIENT_TOKENS } from '@/modules/API/apiClient/linkApiClient.ts'

interface RevokeTokenClientApiProps {
    open: boolean
    handleClose: () => void
    id: number
    name: string
    refetch: () => void
}

const RevokeTokenClientApiDialog: FunctionComponent<RevokeTokenClientApiProps> = ({
    open,
    handleClose,
    id,
    name,
    refetch
}: RevokeTokenClientApiProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [revokeTokenApiClient] = useMutation(REVOKE_ALL_API_CLIENT_TOKENS, {
        variables: {
            id: id
        },
        onCompleted: () => {
            showNotificationSuccess(t('tokenRevoked'))

            refetch()
            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorRevokedToken'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('revokeToken')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('confirmRevokeTokenApiClientMessage')}</p>
                <p className={styles.Informations}>
                    {name} #{id}
                </p>
                <p className={styles.Text}>{t('noRollBack')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={revokeTokenApiClient}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default RevokeTokenClientApiDialog
